var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("page-header", {
        attrs: {
          light: "",
          "dark-crumb": "",
          title: "Согласие на обработку персональных данных",
        },
      }),
      _c("content-wrapper-block", [
        _c("div", { staticClass: "data-consent" }, [
          _c("div", { staticClass: "data-consent-text" }, [
            _c("p", [
              _vm._v(
                " Я даю согласие Акционерному обществу «ГК ОСНОВА», зарегистрированного по адресу: 142702, Московская обл., город Видное, поселок городского типа Бутово, территория жилой комплекс Бутово-Парк, д. 18, пом. 59 (далее - Оператор) на обработку своих персональных данных на следующих условиях: "
              ),
            ]),
            _c("p", [_c("b", [_vm._v("Цели обработки Персональных данных:")])]),
            _c("p", [
              _vm._v(" - идентификация, создания учетной записи;"),
              _c("br"),
              _vm._v(
                " - проведение Оператором маркетинговых исследований, опросов по качеству обслуживания, прочих опросов; "
              ),
              _c("br"),
              _vm._v(
                " - организация стимулирующих мероприятий (акции, конкурсы и пр.) и программы лояльности Оператора; "
              ),
              _c("br"),
              _vm._v("- анализ информации, хранимой в файлах cookies;"),
              _c("br"),
              _vm._v("- совершенствование и развитие деятельности Оператора;"),
              _c("br"),
              _vm._v(
                " - оказание информационных, справочных и консультационных услуг в рамках телефонного обслуживания; "
              ),
              _c("br"),
              _vm._v(
                " - обработку, рассмотрение поступающих обращений, предоставление эффективной поддержки при возникновении проблем. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("Перечень обрабатываемых персональных данных:")]),
            ]),
            _c("p", [
              _vm._v(" - фамилия, имя, отчество;"),
              _c("br"),
              _vm._v(
                " - контактные данные (номер телефона, адрес электронной почты, псевдоним (идентификатор) в социальных сетях и сервисах коммуникаций); "
              ),
              _c("br"),
              _vm._v("- электронные пользовательские данные (файлы cookies). "),
            ]),
            _c("p", [
              _c("b", [_vm._v("Действия с персональными данными:")]),
              _vm._v(
                " автоматизированная и неавтоматизированная (смешанная) обработка посредством осуществления следующих действий: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, передача (предоставление, доступ), блокирование, удаление, уничтожение. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("Сроки обработки персональных данных:")]),
              _vm._v(
                " с момента предоставления настоящего согласия до достижения целей обработки или до отзыва согласия. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("Порядок отзыва:")]),
              _vm._v(
                " настоящее Согласие может быть отозвано мной в любой момент времени, путем направления письменного запроса в адрес Оператора или на электронную почту: "
              ),
              _c("a", { attrs: { href: "mailto:info@gk-osnova.ru" } }, [
                _vm._v("info@gk-osnova.ru"),
              ]),
              _vm._v(". "),
            ]),
            _c("p", [
              _vm._v(
                " Настоящее согласие имеет юридическую силу, считается заполненным и является подписанным с момента заполнения формы путем принятия условий и проставления графического элемента согласия («галочки» в соответствующем чек-боксе), являющегося заменой собственноручной подписи. "
              ),
            ]),
            _c("p", [
              _vm._v(
                " Политика обработки персональных данных расположена по адресу: "
              ),
              _c(
                "a",
                {
                  staticClass: "breakable-link",
                  attrs: {
                    href: "/Политика_обработки_персональных_данных.pdf",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "https://zk-mainstreet.ru/Политика_обработки_персональных_данных.pdf"
                  ),
                ]
              ),
              _vm._v(". "),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }